<template>
  <button type="button" class="btn btn-secondary" @click="showModal()"><font-awesome-icon icon="cog" /> Einstellungen</button>

  <!-- Create Varaible Modal -->
  <div
    class="modal fade"
    :id="'editAbschnittRegelnModal-' + index"
    tabindex="-1"
    aria-labelledby="editAbschnittRegelnModal"
    aria-hidden="true"
    ref="editAbschnittRegelnModalRef"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header bg-primary py-2">
          <h5 class="modal-title my-auto" id="editAbschnittRegelnModalLabel">Einstellungen</h5>

          <button type="button" class="btn-close btn-sm text-white" @click="closeModal()"></button>
        </div>

        <div class="modal-body" id="editAbschnittRegelnModalBody">
          <nav>
            <div class="nav nav-tabs" id="nav-tabs" role="tablist">
              <button
                class="nav-link active"
                :id="'nav-tab-settings-' + index"
                data-bs-toggle="tab"
                :data-bs-target="'#nav-settings-' + index"
                type="button"
                role="tab"
                :aria-controls="'nav-settings-' + index"
                aria-selected="true"
              >
                Einstellungen
              </button>

              <button
                class="nav-link"
                :id="'nav-tab-required-' + index"
                data-bs-toggle="tab"
                :data-bs-target="'#nav-required-' + index"
                type="button"
                role="tab"
                :aria-controls="'nav-required-' + index"
                aria-selected="true"
                :disabled="!textbausteinRegel?.optional || !textbausteinRegel?.aktiv"
              >
                Benötigt
              </button>

              <button
                class="nav-link"
                :id="'nav-tab-forbidden-' + index"
                data-bs-toggle="tab"
                :data-bs-target="'#nav-forbidden-' + index"
                type="button"
                role="tab"
                :aria-controls="'nav-forbidden-' + index"
                aria-selected="false"
                :disabled="!textbausteinRegel?.optional || !textbausteinRegel?.aktiv"
              >
                Gesperrt
              </button>
            </div>
          </nav>

          <div class="tab-content py-3" id="nav-content">
            <!-- Settings -->
            <div class="tab-pane fade show active" :id="'nav-settings-' + index" role="tabpanel" :aria-labelledby="'nav-tab-settings-' + index" tabindex="0">
              <p>
                Abschnitt
                <i>
                  <strong>{{ textbaustein.name }}</strong>
                  <span v-if="textbaustein.titel.length > 0"> ({{ textbaustein.titel }})</span>
                </i>
                ist:
              </p>

              <div v-if="textbausteinRegel != undefined" class="mb-4 w-25">
                <select class="form-select" aria-label="Standardbaustein" v-model="abschnittStatus" @change="setRegeln()">
                  <option value="standard">Standardabschnitt</option>
                  <option value="optional">Optionaler Abschnitt</option>
                  <option value="inaktiv">Inaktiver Abschnitt</option>
                </select>
              </div>
            </div>

            <!-- Required -->
            <div class="tab-pane fade" :id="'nav-required-' + index" role="tabpanel" :aria-labelledby="'nav-tab-required-' + index" tabindex="0">
              <p>
                Wenn Abschnitt
                <i>
                  <strong>{{ textbaustein.name }}</strong>
                  <span v-if="textbaustein.titel.length > 0"> ({{ textbaustein.titel }})</span>
                </i>
                ausgewählt ist, werden folgende optionale Abschnitte automatisch ausgewählt:
              </p>

              <div v-for="abschnitt in vorlage.vorlageTextbausteine.map((a) => a.textbaustein)" :key="abschnitt.id" class="mb-2">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    :value="abschnitt.id"
                    :id="'required-check-' + index + '-' + abschnitt.id"
                    v-model="requiredList"
                    :disabled="
                      (abschnitt.id === textbaustein.id ||
                        abschnitt.id == textbaustein.ownerid ||
                        forbiddenList.includes(abschnitt.id) ||
                        textbausteinIsDefaultOrInactive(abschnitt.id)) &&
                      !requiredList.includes(abschnitt.id)
                    "
                  />
                  <label class="form-check-label" :for="'required-check-' + index + '-' + abschnitt.id">
                    <span>
                      <strong>{{ abschnitt.name }}</strong>
                      <span v-if="abschnitt.titel.length > 0"> ({{ abschnitt.titel }})</span>
                    </span>
                  </label>
                </div>

                <div v-if="abschnitt.abschnitte && abschnitt.abschnitte.length > 0" class="ms-4 mt-2">
                  <div v-for="subabschnitt in abschnitt.abschnitte" :key="subabschnitt.id" class="form-check mb-1">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      :value="subabschnitt.id"
                      :id="'sub-required-check-' + index + '-' + abschnitt.id + '-' + subabschnitt.id"
                      v-model="requiredList"
                      :disabled="
                        subabschnitt.id === textbaustein.id ||
                        subabschnitt.ownerid === textbaustein.id ||
                        forbiddenList.includes(subabschnitt.id) ||
                        forbiddenList.includes(abschnitt.id) ||
                        textbausteinIsDefaultOrInactive(subabschnitt.id)
                      "
                    />
                    <label class="form-check-label" :for="'sub-required-check-' + index + '-' + abschnitt.id + '-' + subabschnitt.id">
                      <span>
                        <strong>{{ subabschnitt.name }}</strong>
                        <span v-if="subabschnitt.titel.length > 0"> ({{ subabschnitt.titel }})</span>
                      </span>
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <!-- Forbidden -->
            <div class="tab-pane fade" :id="'nav-forbidden-' + index" role="tabpanel" :aria-labelledby="'nav-tab-forbidden-' + index" tabindex="1">
              <p>
                Wenn Abschnitt
                <i>
                  <strong>{{ textbaustein.name }}</strong>
                  <span v-if="textbaustein.titel.length > 0"> ({{ textbaustein.titel }})</span>
                </i>
                ausgewählt ist, können folgende optionale Abschnitte nicht ausgewählt werden:
              </p>

              <div v-for="abschnitt in vorlage.vorlageTextbausteine.map((a) => a.textbaustein)" :key="abschnitt.id" class="mb-2">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    :value="abschnitt.id"
                    :id="'forbidden-check-' + index + '-' + abschnitt.id"
                    v-model="forbiddenList"
                    :disabled="
                      abschnitt.id === textbaustein.id ||
                      abschnitt.id == textbaustein.ownerid ||
                      requiredList.includes(abschnitt.id) ||
                      textbausteinIsDefaultOrInactive(abschnitt.id)
                    "
                  />
                  <label class="form-check-label" :for="'forbidden-check-' + index + '-' + abschnitt.id">
                    <span>
                      <strong>{{ abschnitt.name }}</strong>
                      <span v-if="abschnitt.titel.length > 0"> ({{ abschnitt.titel }})</span>
                    </span>
                  </label>
                </div>

                <div v-if="abschnitt.abschnitte && abschnitt.abschnitte.length > 0" class="ms-4 mt-2">
                  <div v-for="subabschnitt in abschnitt.abschnitte" :key="subabschnitt.id" class="form-check mb-1">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      :value="subabschnitt.id"
                      :id="'sub-forbidden-check-' + index + '-' + abschnitt.id + '-' + subabschnitt.id"
                      v-model="forbiddenList"
                      :disabled="
                        subabschnitt.id === textbaustein.id ||
                        subabschnitt.ownerid === textbaustein.id ||
                        requiredList.includes(subabschnitt.id) ||
                        textbausteinIsDefaultOrInactive(subabschnitt.id)
                      "
                    />
                    <label class="form-check-label" :for="'sub-forbidden-check-' + index + '-' + abschnitt.id + '-' + subabschnitt.id">
                      <span>
                        <strong>{{ subabschnitt.name }}</strong>
                        <span v-if="subabschnitt.titel.length > 0"> ({{ subabschnitt.titel }})</span>
                      </span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-primary" @click="closeModal()">Okay</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  //#region Imports
  import { PropType, ref, computed, watch } from 'vue';
  import { Modal } from 'bootstrap';

  import { AbschnittRegel, Textbaustein, Vorlage, VorlageTextbaustein } from '@/models/VorlageModels';
  //#endregion

  const { index, vorlageTextbaustein, textbaustein, vorlage } = defineProps({
    index: {
      type: Number as PropType<number>,
      default: 0,
    },

    vorlage: {
      type: Object as PropType<Vorlage>,
      required: true,
    },

    vorlageTextbaustein: {
      type: Object as PropType<VorlageTextbaustein>,
      required: true,
    },

    textbaustein: {
      type: Object as PropType<Textbaustein>,
      required: true,
    },
  });

  const textbausteinRegel = computed(() => vorlageTextbaustein.abschnittRegeln.find((r) => r.textbausteinId === textbaustein.id));

  const requiredList = ref<Array<number>>(new Array<number>());
  const forbiddenList = ref<Array<number>>(new Array<number>());

  function textbausteinIsDefaultOrInactive(textbausteinId: number): boolean {
    let vorlageBaustein: VorlageTextbaustein | undefined = undefined;

    for (let vt of vorlage.vorlageTextbausteine) {
      if (vt.abschnittRegeln.map((r) => r.textbausteinId).includes(textbausteinId)) {
        vorlageBaustein = vt;
        break;
      }
    }

    if (vorlageBaustein == undefined) return false;

    const regel = vorlageBaustein.abschnittRegeln.find((r) => r.textbausteinId === textbausteinId);
    return regel != undefined && (!regel.optional || !regel.aktiv);
  }

  const abschnittStatus = ref('optional');

  function setRegeln() {
    switch (abschnittStatus.value) {
      case 'standard':
        if (textbausteinRegel.value) {
          textbausteinRegel.value.optional = false;
          textbausteinRegel.value.aktiv = true;
        }
        break;

      case 'optional':
        if (textbausteinRegel.value) {
          textbausteinRegel.value.optional = true;
          textbausteinRegel.value.aktiv = true;
        }
        break;

      case 'inaktiv':
        if (textbausteinRegel.value) {
          textbausteinRegel.value.aktiv = false;

          removeAllRegelnByTextbausteinId(textbaustein.id);

          setSubabschnitteInactive();
        }
        break;
    }

    if (textbausteinRegel.value && (!textbausteinRegel.value.aktiv || !textbausteinRegel.value.optional)) {
      textbausteinRegel.value.regeln = new Array<AbschnittRegel>();
      requiredList.value = new Array<number>();
      forbiddenList.value = new Array<number>();
    }
  }

  function setSubabschnitteInactive() {
    if (textbaustein.abschnitte != undefined && textbaustein.abschnitte.length > 0) {
      for (let sub of textbaustein.abschnitte) {
        let subRegel = vorlageTextbaustein.abschnittRegeln.find((r) => r.textbausteinId === sub.id);
        if (subRegel) {
          subRegel.aktiv = false;
          subRegel.regeln = new Array<AbschnittRegel>();
          removeAllRegelnByTextbausteinId(sub.id);
        }
      }
    }
  }

  function removeAllRegelnByTextbausteinId(textbausteinId: number) {
    for (const vt of vorlage.vorlageTextbausteine) {
      for (let abschnittRegel of vt.abschnittRegeln) {
        abschnittRegel.regeln = abschnittRegel.regeln.filter((r) => r.textbausteinId !== textbausteinId);
      }
    }
  }

  watch(requiredList, () => {
    if (textbausteinRegel.value) {
      textbausteinRegel.value.regeln = textbausteinRegel.value.regeln.filter((r) => r.effekt != 1);

      for (let id of requiredList.value) {
        textbausteinRegel.value.regeln.push(new AbschnittRegel(textbausteinRegel.value.id, id, 1));

        let baustein: Textbaustein | undefined = undefined;
        for (let t of vorlage.vorlageTextbausteine.map((a) => a.textbaustein)) {
          if (t.id == id) {
            baustein = t;
            break;
          }

          if (t.abschnitte && t.abschnitte.length > 0) {
            for (let sub of t.abschnitte) {
              if (sub.id == id) {
                baustein = sub;
                break;
              }
            }
          }
        }

        if (
          baustein != undefined &&
          baustein.ownerid != undefined &&
          baustein.ownerid != textbaustein.id &&
          !requiredList.value.includes(baustein.ownerid) &&
          !forbiddenList.value.includes(baustein.ownerid)
        ) {
          textbausteinRegel.value.regeln.push(new AbschnittRegel(textbausteinRegel.value.id, baustein.ownerid, 1));
          requiredList.value.push(baustein.ownerid);
        }
      }
    }
  });

  watch(forbiddenList, () => {
    if (textbausteinRegel.value) {
      textbausteinRegel.value.regeln = textbausteinRegel.value.regeln.filter((r) => r.effekt != 2);

      for (let id of forbiddenList.value) {
        textbausteinRegel.value.regeln.push(new AbschnittRegel(textbausteinRegel.value.id, id, 2));
      }
    }
  });

  //#region Modal
  const editAbschnittRegelnModalRef = ref();

  function closeModal() {
    Modal.getInstance(editAbschnittRegelnModalRef.value)?.hide();
  }

  function showModal() {
    if (editAbschnittRegelnModalRef.value) {
      if (textbausteinRegel.value != undefined && textbausteinRegel.value.regeln != undefined) {
        requiredList.value = textbausteinRegel.value?.regeln.filter((r) => r.effekt == 1).map((r) => r.textbausteinId) ?? new Array<number>();
        forbiddenList.value = textbausteinRegel.value?.regeln.filter((r) => r.effekt == 2).map((r) => r.textbausteinId) ?? new Array<number>();

        if (!textbausteinRegel.value.aktiv) {
          abschnittStatus.value = 'inaktiv';
        } else if (textbausteinRegel.value.optional) {
          abschnittStatus.value = 'optional';
        } else {
          abschnittStatus.value = 'standard';
        }
      } else {
        requiredList.value = new Array<number>();
        forbiddenList.value = new Array<number>();
      }

      new Modal(editAbschnittRegelnModalRef.value).show();
    }
  }
  //#endregion
</script>

<style scoped>
  .modal-body {
    cursor: default;
  }
</style>
